
import homeImage from "../../assets/storey_night.png";
import taggedImage from "../../assets/geo-tagged.png";
import planetImage from "../../assets/planet-earth.png";
import visibleImage from "../../assets/visibility-eye.png";
import verifiedImage from "../../assets/verified.png";
import craneImage from "../../assets/crane.png";
import { useNavigate } from "react-router-dom";

const MainHome = () => {
    const navigate = useNavigate();
    const handleExploreFeatures = () => {
        navigate("/feature", { state: { feat: "ConRa" } });
    };
    return (
        <div>
            <div className="home-wrapper">
                <section className="home-section">
                    <div className="home-text">
                        <h1 className="h1-48-800">ConRa Build Back Home <br />
                            <span className="custom-underline" > With Confidence.</span>
                        </h1>
                        <p>
                            Distance shouldn’t disconnect you from your project. ConRa helps build your
                            home brick by brick from excavation to roofing
                        </p>
                    </div>
                    <div className="home-image">
                        <img src={homeImage} alt="Team meeting" />
                    </div>
                </section>

                <div className="home-section-special">
                    <h1 className="h1-48-800"> Why<span > ConRa</span>
                    </h1>
                    <div className="home-text">
                        <p className="home-text-p-right">See what’s happening on your site without relying on calls or asssumptions.</p>
                    </div>
                </div>

                <section className="home-section">
                    <div className="about-image-reverse">
                        <img src={taggedImage} alt="Team meeting" />
                        <p>Your invesement deserves transparency. ConRa helps reduce miscommunication delays and uncertainity by keeping all project updates documented and visible wherever you are in the world</p>
                    </div>
                    <div className="home-text">
                        <div>
                            <img src={visibleImage} alt="Team meeting" />
                            <h3>Full Visibility</h3>
                            <p className="paragraph">See what’s happening on your site without relying on calls or asssumptions.</p>
                        </div>
                        <div>
                            <img src={verifiedImage} alt="Team meeting" />
                            <h3>Verified Progres Updates</h3>
                            <p className="paragraph">Photos, logs and milestones. All in one place.</p>
                        </div>
                        <div>
                            <img src={craneImage} alt="Team meeting" />
                            <h3>End-to-End Tracking</h3>
                            <p className="paragraph">From groundworks to finishes, follow every stage of construction</p>
                        </div>
                        <div>
                            <img src={planetImage} alt="Team meeting" />
                            <h3>Built for Diaspora Living</h3>
                            <p className="paragraph">Designed for homeowners managing projects remotely</p>
                        </div>
                    </div>
                </section>


            </div>
        </div>
    );
};

export default MainHome;



// const TestimonialCard = ({ data }) => (
//     <div className="testimonial-card">
//         <div className="card-header">
//             <div className="avatar-container">
//                 {data.isLogoAvatar ? (
//                     <div className="avatar-logo" style={{ backgroundColor: data.logoColor || '#ddd' }}>
//                         <span className="logo-initial">{data.name.charAt(0)}</span>
//                     </div>
//                 ) : (
//                     <img src={data.avatar} alt={data.name.charAt(0)} className="avatar-img" />
//                 )}
//             </div>
//             <div className="user-info">
//                 <h4 className="user-name">{data.name}</h4>
//                 <p className="user-role">{data.role}</p>
//             </div>
//         </div>
//         <div >
//             <p className="testimonial-text">{data.text}</p>
//         </div>
//     </div>
// );